<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="margin-b">
                    <div class="card">
                        <div class="card-body cursor" (click)="navigate()">
                            <div class="display">
                                <div class="image-wrapper wrapper-style">
                                    <img class="wrapper-style" src="assets/church_image.jpg"
                                        (error)="getErrorImage($event)">
                                </div>
                                <div class="text-area">
                                    <input type="text" class="form-control cursor" (click)="navigate()"
                                        placeholder="Let your words honor the Lord....">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!loading">

                    <div *ngFor="let props of arr">
                        <app-card-skelton title='Social Feed'></app-card-skelton>
                    </div>
                </div>

                <app-no-results-found *ngIf="postArr.length == 0" title='Social Feed'>
                </app-no-results-found>



                <div *ngIf="loading">
                    <div *ngFor="let props of (postArr  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: pageNo,
                        totalItems: totalItems

                      }); let i = index" class="card margin-b">
                        <div class="card-body card-body-noshadow">
                            <div class="display margin-b">
                                <div class="image-wrapper wrapper-style">
                                    <img class="wrapper-style" [src]="props?.postedBy?.user?.photo"
                                        (error)="getErrorImage($event)">
                                </div>
                                <div class="text-area">
                                    <div class="display justify-content" style="margin-top: 20px;">
                                        <div>
                                            <h5 class="card-title">{{props?.postedBy?.user?.name | titlecase}}</h5>
                                        </div>
                                        <div>
                                            <div class="dropdown">
                                                <button class="btn  dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a *ngIf="showDelete" class="dropdown-item cursor"
                                                        (click)="reportPost(props._id)">Report</a>
                                                    <a *ngIf="!showDelete" class="dropdown-item cursor"
                                                        (click)="deletePost(props._id,i)">Delete</a>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="time-text">
                                        <!-- <span>
                                            <p>July at 7:13 AM</p>
                                        </span> -->
                                    </div>
                                </div>
                            </div>
                            <p class="card-text">{{props.text}}</p>
                        </div>
                        <div *ngIf="props.type != 'text'" class="image-wrapper">
                            <img class="card-img-bottom" [src]="props.photo" alt="image"
                                (error)="getErrorImage($event)">
                        </div>
                        <div class="card-body" style="text-align:right;">
                            <div style="display: inline-flex;">
                                <div class="cursor" (click)="likePost(props)
                                    ">
                                    <span *ngIf="!props.isLiked"><i class="far fa-thumbs-up margin-l"></i></span>
                                    <span *ngIf="props.isLiked"> <i class="fas fa-thumbs-up margin-l"></i>
                                    </span>

                                    <span style="margin-left: 5px;">Like {{props.likes}}</span>
                                </div>

                                <div class="margin-l cursor" (click)="navigateComments(props._id)">
                                    <span><i class="far fa-comment-dots "></i></span>
                                    <span style="margin-left: 5px;">Comments</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="postArr?.length > 0 "
                        (pageChange)="page = getSocialPosts($event)" directionLinks="true" autoHide="false"
                        responsive="true" previousLabel="Previous" nextLabel="Next"
                        screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>



            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>